import React from 'react'
import classNames from 'classnames'

import s from './HTMLTextFromMarkdown.less'

const HTMLTextFromMarkdown = ({ htmlText, className, as = 'div' }) => {
  if (!htmlText) return <></>

  const As = as

  return <As className={classNames(s.root, className)} dangerouslySetInnerHTML={{ __html: htmlText.trim() }} />
}

export default HTMLTextFromMarkdown
